import { LogicNodeDefinition } from '../LogicNodeDefinition';

interface RandomNodeState {
  prevInput: boolean;
  currentOutput: boolean;
}

export const RandomNode: LogicNodeDefinition<RandomNodeState> = {
  type: 'RANDOM',
  createDefaultState: () => ({
    prevInput: false,
    currentOutput: Math.random() > 0.5,
  }),
  needsInputSync: (input, state) => input !== state.prevInput,
  process: (input, state) => {
    if (!state.prevInput && input) {
      // Rising edge
      state.currentOutput = Math.random() > 0.5;
    }
    state.prevInput = input;
    return state.currentOutput;
  },
};
